// This file is automatically generated by scripts/build-corejs3-shipped-proposals.mjs

export default new Set<string>([
  "esnext.array.group",
  "esnext.array.group-to-map",
  "esnext.json.is-raw-json",
  "esnext.json.parse",
  "esnext.json.raw-json",
  "esnext.math.sum-precise",
  "esnext.symbol.metadata",
  "esnext.uint8-array.from-base64",
  "esnext.uint8-array.from-hex",
  "esnext.uint8-array.set-from-base64",
  "esnext.uint8-array.set-from-hex",
  "esnext.uint8-array.to-base64",
  "esnext.uint8-array.to-hex",
]);
